  <template>
  <div id="notifications">
        <div class="panel-header">
            <p>notifications</p>
            <div v-if="unseenNotifications.length > 0">
                <p>{{ unseenNotifications.length }}</p>
            </div>
        </div>
        <div class="panel-body">
            <ul>
                <li
                    v-for="(notification) in sortedNotifications" 
                    :key="`notification-${notification.id}`"
                    @click="toDashboard(notification)"
                    :class="{'unseen': unseenNotifications.includes(notification)}"
                    class="notification-item">
                        <div v-if="notification.message">
                            <Icon :icon="notification.type | icon"/>
                            <p v-html="notification.message" :class="{'w-100': notification.locked}"></p>
                        </div>
                </li>
            </ul>
        </div>
    </div>
    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Icon from '@/components/Theme/Icon'
import {isActionAfterAccecibleDate} from '../core/utils/trial.utils'

export default {
    name: 'UserBox',
    components: {
        Icon
    },
    computed: {
        ...mapState([
            'user',
            'notifications'
        ]),
        ...mapGetters(['lastAccecibleDate']),
        sortedNotifications(){
            return this.notifications.sort((a,b) => a.date - b.date)
        },
        unseenNotifications() {
            return this.notifications.filter(item => !item.seen)
        },
    },
    filters: {
        icon: (type) => {
            switch(type) {
                case 'cp-request':
                    return 'cp-request-icon'
                case 'counter-offer':
                    return 'counter-offer-icon'
                case 'update-posted':
                    return 'update-posted-icon'
                case 'update-draft-posted':
                case 'update-draft-updated':
                    return 'kickstarter-green'
                case 'update-draft-not-posted':
                    return 'decline-request-icon'
                case 'update-reminder':
                    return 'update-reminder-icon'
                case 'request-declined':
                case 'request-decline':
                    return 'decline-request-icon'
                case 'request-accept':
                case 'request-accepted':
                    return 'accept-request-icon'
            }
        } 
    },
    methods: {
        toDashboard(notification) {
            this.$ga.event('Notification', 'Notification Item Click')
            this.$sendMixpanelEvent('Notification Item Clicked')

            const {type, externalUrl} = notification
            const id = (['update-reminder', 'update-draft-not-posted'].includes(notification.type)) ? notification.updateId : notification.cprequestId

            this.$emit('markAsSeen')

            if(externalUrl){
                window.open(externalUrl, '_blank');
                return
            }

            let section = 'requests'
            let sectionTab = 'received'

            switch(type){
                case 'request-declined':
                case 'request-decline':
                case 'request-accept':
                case 'request-accepted':
                    sectionTab = 'sent'
                    break
                case 'update-reminder':
                case 'update-draft-not-posted':
                    section = 'updates'
                    sectionTab = 'scheduled'
                    break
            }
            this.$router.push({
                path: `/dashboard/${section}`,
                query: {
                    ...this.$route.query,
                    type: sectionTab,
                    page: undefined,
                    filters: undefined,
                    id
                }
            }).catch(() => {})
        },
    }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
div#notifications {
    width: 320px;
    background: #ffffff;
    position: absolute;
    top: 35px;
    right: 0;
    z-index: 9999;
    border-radius: 10px;
    box-shadow: 0px 0px 75px rgba(0, 0, 0, 0.17);

    div.panel-header {
        display: flex;
        justify-content: space-between;
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 24px;
        padding-right: 24px;
        border-bottom: 1px solid $c10;
        p {
            color: $c3;
            font-size: $p5;
            font-weight: $weight_bold;
            text-transform: uppercase;
            margin: 0;
        }
        div {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: $c5;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
                color: $c14;
                font-size: $p5;
            }
        }

    }

    div.panel-body {
        max-height: 352px;
        overflow-y: auto;
        ul {
            margin: 0;
            padding: 0;
            li.notification-item {
                padding: 8px 24px;
                border-bottom: 1px solid $c10;
                cursor: pointer;
                transition: all 0.2s ease;
                &:last-child {
                    border: 0 !important;
                }
                &:hover {
                    background: $c11;
                }
                &.unseen {
                    background: $c11;
                }
                div {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 100%;
                    p {
                        font-size: $p4;
                        margin-bottom: 0;
                        margin-left: 16px;
                    }
                }
            }
        }
    }
}
</style>

